import { showHttpError } from '@calendly/alert'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { historyPush } from 'actions/core/navigation'

import { getManagedEventTypeMemberships } from '../../../api'

export const fetchManagedEventTypeMemberships = createAsyncThunk(
  'managedEventTypeMemberships/fetchOrganizationInvitations',
  async ({ managedEventTypeId }, { rejectWithValue, dispatch }) => {
    const [success, response] = await getManagedEventTypeMemberships(managedEventTypeId, { scope: 'invitations' })

    if (!success) {
      const url = '/app/admin/managed_event_types'

      dispatch(historyPush(url))
      dispatch(showHttpError(response))
      return rejectWithValue([])
    }

    return response
  }
)

const initialState = {
  list: [],
  status: 'initial'
}

const slice = createSlice({
  name: 'managedEventTypeMemberships/organizationInvitations',
  initialState,
  reducers: {
    resetState: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(fetchManagedEventTypeMemberships.pending, (state) => {
      state.status = 'loading'
    })
    builder.addCase(fetchManagedEventTypeMemberships.fulfilled, (state, action) => {
      state.status = 'loaded'
      state.list = action.payload
    })
    builder.addCase(fetchManagedEventTypeMemberships.rejected, (state) => {
      state.status = 'failed'
    })
  }
})

export const { actions: { resetState }, reducer } = slice
